export type ProfileSectionId =
  | 'account'
  | 'personal'
  | 'academic'
  | 'education'
  | 'employment'
  | 'publications'
  | 'projects'
  | 'achievements'
  | 'documents'
  | 'completion'
  | 'settings';

export type ProfileSection = {
  id: ProfileSectionId;
  num: string;
  title: string;
  text: string;
  accent: string;
  pct: number;
  icon: string;
};

/** Line icons matching ZA183 template (stroke SVG). */
export const PROFILE_ICONS: Record<ProfileSectionId, string> = {
  account:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c.6-5 3.2-8 8-8s7.4 3 8 8"/></svg>',
  personal:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="8" r="3"/><circle cx="17" cy="10" r="2"/><path d="M3 20c.4-4 2.6-6 6-6s5.6 2 6 6M15 15c2.8.2 4.5 1.9 5 5"/></svg>',
  academic:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8l9-5 9 5-9 5-9-5Z"/><path d="M6 10v6c3 3 9 3 12 0v-6M21 8v7"/></svg>',
  education:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h12a3 3 0 0 1 3 3v13H7a3 3 0 0 1-3-3V4Z"/><path d="M7 7h8M7 11h8M7 15h5"/></svg>',
  employment:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h18v13H3V7Z"/><path d="M8 7V4h8v3M3 12h18M10 12v2h4v-2"/></svg>',
  publications:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 3h11l3 3v15H5V3Z"/><path d="M16 3v4h4M8 11h8M8 15h8M8 7h4"/></svg>',
  projects:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h7l2 3h7v11H4V5Z"/><path d="M8 13h8M12 10v6"/></svg>',
  achievements:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 3h8v5a4 4 0 0 1-8 0V3Z"/><path d="M8 5H4v2c0 3 2 5 5 5M16 5h4v2c0 3-2 5-5 5M12 12v5M8 21h8M9 17h6"/></svg>',
  documents:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 3h10l4 4v14H5V3Z"/><path d="M15 3v5h5M8 12h8M8 16h8"/></svg>',
  completion:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v14H4V5Z"/><path d="M8 9h8M8 13h5M16 15l1.5 1.5L21 13"/></svg>',
  settings:
    '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/></svg>',
};

export const PROFILE_SECTIONS: ProfileSection[] = [
  {
    id: 'account',
    num: '01',
    title: 'Учётная запись',
    text: 'ID, email, телефон, язык и безопасность',
    accent: '#41d2ff',
    pct: 0,
    icon: PROFILE_ICONS.account,
  },
  {
    id: 'personal',
    num: '02',
    title: 'Личные данные',
    text: 'ФИО на трёх языках, фото и локация',
    accent: '#49ddb7',
    pct: 0,
    icon: PROFILE_ICONS.personal,
  },
  {
    id: 'academic',
    num: '03',
    title: 'Академический профиль',
    text: 'ORCID, Scopus, WoS, интересы и экспертиза',
    accent: '#9e80ff',
    pct: 0,
    icon: PROFILE_ICONS.academic,
  },
  {
    id: 'education',
    num: '04',
    title: 'Образование',
    text: 'Ступени образования и программы',
    accent: '#e2ad3a',
    pct: 0,
    icon: PROFILE_ICONS.education,
  },
  {
    id: 'employment',
    num: '05',
    title: 'Место работы',
    text: 'Организации, должности и трудовая история',
    accent: '#ff8b75',
    pct: 0,
    icon: PROFILE_ICONS.employment,
  },
  {
    id: 'publications',
    num: '06',
    title: 'Публикации',
    text: 'Единый реестр публикаций',
    accent: '#41d2ff',
    pct: 0,
    icon: PROFILE_ICONS.publications,
  },
  {
    id: 'projects',
    num: '07',
    title: 'Проекты и гранты',
    text: 'Проекты, гранты и исследовательские роли',
    accent: '#49ddb7',
    pct: 0,
    icon: PROFILE_ICONS.projects,
  },
  {
    id: 'achievements',
    num: '08',
    title: 'Достижения',
    text: 'Награды, сертификаты и результаты',
    accent: '#e2ad3a',
    pct: 0,
    icon: PROFILE_ICONS.achievements,
  },
  {
    id: 'documents',
    num: '09',
    title: 'Документы',
    text: 'Безопасные документы и хранилище файлов',
    accent: '#41d2ff',
    pct: 0,
    icon: PROFILE_ICONS.documents,
  },
  {
    id: 'completion',
    num: '10',
    title: 'Защита и диплом',
    text: 'Защита, решение, диплом и трудоустройство',
    accent: '#9e80ff',
    pct: 0,
    icon: PROFILE_ICONS.completion,
  },
  {
    id: 'settings',
    num: '11',
    title: 'Настройки',
    text: 'Приватность, публичный профиль, сессии и экспорт',
    accent: '#ff8b75',
    pct: 0,
    icon: PROFILE_ICONS.settings,
  },
];

export const isProfileSectionId = (value: string | undefined): value is ProfileSectionId =>
  Boolean(value && PROFILE_SECTIONS.some((section) => section.id === value));

/** Matches ZA183: ready sections are those with score ≥ 70%. */
export function profileCompleteness(sections: ProfileSection[] = PROFILE_SECTIONS) {
  const filled = sections.filter((section) => section.pct >= 70).length;
  const score = Math.round(sections.reduce((sum, section) => sum + section.pct, 0) / sections.length);
  return { filled, total: sections.length, score };
}
